import React, { useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Link from "./link"
import { htmlDecode } from "../Utils"

export default ({
  key,
  heading=null,
  subText=null,
  resources=null,
  posts=null
}) => {

  const cdnUrl = 'https://dlyog079eaher.cloudfront.net';

  if ((!resources || resources.length <= 0) && (!posts || posts.length <= 0)) {
    const resourceData = useStaticQuery(graphql`
      query RelatedContent {
        allStrapiResource(limit: 4) {
          edges {
            node {
              title
              customerVideoContent
              slug
              featuredImage {
                alternativeText
                url
                formats {
                  medium {
                    url
                  }
                }
              }
              content
              resource_categories {
                name
                slug
              }
            }
          }
        }
      }
    `)
    resources = []
    const edges = resourceData.allStrapiResource.edges
    for (let i = 0; i < edges.length; i++) resources.push(edges[i].node)
  }

  useEffect(() => {
    resources.forEach((resource) => {
      console.log(resource.featuredImage.url)
    })
  }, [resources]);

  return (
    <div className="tease-items-block related-content bgg1">
      <div className="container">
        <div className="row">
          <div className="col-12">
            {heading &&
              <h2 className={ `content-title text-center ${subText ? "orange-dash" : "mb4"}` }>{ htmlDecode(heading) }</h2>
            }
            {subText &&
              <div className="section-content text-center mb4" dangerouslySetInnerHTML={{ __html: subText }} />
            }
          </div>
        </div>
        <div className="row jcc ais">
          {((resources.length + posts.length) > 4) &&
            <>
              <div id="relatedContentSlideshow" className="flexslider" style={{width: "100%"}}>
                <ul className="slides">
                  {resources && resources.map((resource, index) => (
                      <li className="slide list-item">
                        <div className="slider_list-item-inner">
                          <div className="list-content bgw br3 ofh bs1">
                            <div className="slider_content-wrap">
                              {resource.featuredImage &&
                              <Link href={ `/resource/${resource.slug}/` } title={ htmlDecode(resource.title) } className="dbha" target="_blank">
                                {resource.featuredImage.formats.medium &&
                                <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${resource.featuredImage.formats.medium.url.includes(cdnUrl) ? resource.featuredImage.formats.medium.url : cdnUrl + resource.featuredImage.formats.medium.url })`, opacity: 1}}/>
                                }
                                {!resource.featuredImage.formats.medium &&
                                <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${resource.featuredImage.url.includes(cdnUrl) ? resource.featuredImage.url : cdnUrl + resource.featuredImage.url})`, opacity: 1}} />
                                }
                              </Link>
                              }
                              <div className="teaser-text-wrap">
                                {resource.resource_categories &&
                                <a href={`/resource-categories/${ resource.resource_categories[0].slug }`} className="mt.5 mb2 cat-btn">{ resource.resource_categories[0].name }</a>
                                }
                                {!resource.resource_categories &&
                                <span className="mt.5 mb2 cat-btn cat-btn-no-hover">Resource</span>
                                }
                                <Link href={ `/resource/${resource.slug}/` } target="_blank">
                                  <h3 className="teaser-header mb1.8">{ htmlDecode(resource.title) }</h3>
                                </Link>
                                <hr className="small orange mb1.8 ml0" />
                                {resource.content &&
                                <p className="copy">{ htmlDecode(resource.content).substr(0, 80) }&hellip;</p>
                                }
                                {(!resource.content && resource.customerVideoContent) &&
                                <p className="copy">{ htmlDecode(resource.customerVideoContent).substr(0, 80) }&hellip;</p>
                                }
                                {(!resource.content && !resource.customerVideoContent && resource.resourceBanner) &&
                                <p className="copy">{ htmlDecode(resource.resourceBanner.resourceSubTitle) }\</p>
                                }
                              </div>
                            </div>
                            <div className="slider_button-wrap">
                              {resource.resource_categories &&
                              <>
                                {resource.resource_categories[0].slug === 'case-study' &&
                                <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Get Case Study</Link>
                                }
                                {resource.resource_categories[0].slug === 'ebook' &&
                                <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Get the E-Book</Link>
                                }
                                {resource.resource_categories[0].slug === 'publication' &&
                                <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">View Publication</Link>
                                }
                                {resource.resource_categories[0].slug === 'thought-leadership' &&
                                <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Learn More</Link>
                                }
                                {resource.resource_categories[0].slug === 'videos' &&
                                <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Watch Video</Link>
                                }
                                {resource.resource_categories[0].slug === 'webinars' &&
                                <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Watch Webinar</Link>
                                }
                                {resource.resource_categories[0].slug === 'whitepapers' &&
                                <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">View Whitepaper</Link>
                                }
                              </>
                              }
                              {!resource.resource_categories &&
                              <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Get Resource</Link>
                              }
                            </div>
                          </div>
                        </div>
                      </li>
                  ))}
                  {posts && posts.map((post, index) => (
                    <li className="slide list-item">
                      <div className="slider_list-item-inner">
                        <div className="list-content bgw br3 ofh bs1">
                          <div className="slider_content-wrap">
                            {post.featuredImage &&
                              <Link href={ `/blog/${post.slug}/` } title={ htmlDecode(post.title) } className="dbha" target="_blank">
                                {post.featuredImage.formats.medium &&
                                <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${post.featuredImage.formats.medium.url.includes(cdnUrl) ? post.featuredImage.formats.medium.url : cdnUrl + post.featuredImage.formats.medium.url })`, opacity: 1}}/>
                                }
                                {!post.featuredImage.formats.medium &&
                                <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${post.featuredImage.url.includes(cdnUrl) ? post.featuredImage.url : cdnUrl + post.featuredImage.url})`, opacity: 1}} />
                                }
                              </Link>
                            }
                            <div className="teaser-text-wrap">
                              <a href="/blog" className="mt.5 mb2 cat-btn">Blog</a>
                              <Link href={ `/blog/${post.slug}/` } target="_blank">
                                <h3 className="teaser-header mb1.8">{ htmlDecode(post.title) }</h3>
                              </Link>
                              <hr className="small orange mb1.8 ml0" />
                              {post.content &&
                                <p className="copy">{ htmlDecode(post.content).substring(0, 80) }&hellip;</p>
                              }
                            </div>
                          </div>
                          <div className="slider_button-wrap">
                            <Link className="button uppercase" href={ `/blog/${post.slug}` } target="_blank">Read More</Link>
                          </div>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </>
          }
          {((resources.length + posts.length) <= 4) &&
            <>
              {resources && resources.map((resource, index) => (
                  <div className="col-12 col-sm-8 col-md-6 col-lg-3 list-item ph2">
                    <div className="static_list-item-inner">
                      <div className="list-content bgw br3 ofh bs1">
                        <div className="static_content-wrap">
                          {resource.featuredImage &&
                          <Link href={ `/resource/${resource.slug}/` } title={ htmlDecode(resource.title) } className="dbha" target="_blank">
                            {resource.featuredImage.formats.medium &&
                            <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${resource.featuredImage.formats.medium.url.includes(cdnUrl) ? resource.featuredImage.formats.medium.url : cdnUrl + resource.featuredImage.formats.medium.url })`, opacity: 1}}/>
                            }
                            {!resource.featuredImage.formats.medium &&
                            <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${resource.featuredImage.url.includes(cdnUrl) ? resource.featuredImage.url : cdnUrl + resource.featuredImage.url})`, opacity: 1}} />
                            }
                          </Link>
                          }
                          <div className="teaser-text-wrap">
                            {resource.resource_categories &&
                            <a href={`/resource-categories/${ resource.resource_categories[0].slug }`} className="mt.5 mb2 cat-btn">{ resource.resource_categories[0].name }</a>
                            }
                            {!resource.resource_categories &&
                            <span className="mt.5 mb2 cat-btn cat-btn-no-hover">Resource</span>
                            }
                            <Link href={ `/resource/${resource.slug}/` } target="_blank">
                              <h3 className="teaser-header mb1.8">{ htmlDecode(resource.title) }</h3>
                            </Link>
                            <hr className="small orange mb1.8 ml0" />
                            {resource.content &&
                            <p className="copy">{ htmlDecode(resource.content).substr(0, 80) }&hellip;</p>
                            }
                            {(!resource.content && resource.customerVideoContent) &&
                            <p className="copy">{ htmlDecode(resource.customerVideoContent).substr(0, 80) }&hellip;</p>
                            }
                            {(!resource.content && !resource.customerVideoContent && resource.resourceBanner) &&
                            <p className="copy">{ htmlDecode(resource.resourceBanner.resourceSubTitle) }\</p>
                            }
                          </div>
                        </div>
                        <div className="static_button-wrap">
                          {resource.resource_categories &&
                          <>
                            {resource.resource_categories[0].slug === 'case-study' &&
                            <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Get Case Study</Link>
                            }
                            {resource.resource_categories[0].slug === 'ebook' &&
                            <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Get the E-Book</Link>
                            }
                            {resource.resource_categories[0].slug === 'publication' &&
                            <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">View Publication</Link>
                            }
                            {resource.resource_categories[0].slug === 'thought-leadership' &&
                            <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Learn More</Link>
                            }
                            {resource.resource_categories[0].slug === 'videos' &&
                            <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Watch Video</Link>
                            }
                            {resource.resource_categories[0].slug === 'webinars' &&
                            <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Watch Webinar</Link>
                            }
                            {resource.resource_categories[0].slug === 'whitepapers' &&
                            <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">View Whitepaper</Link>
                            }
                          </>
                          }
                          {!resource.resource_categories &&
                          <Link className="button uppercase" href={ `/resource/${resource.slug}/` } target="_blank">Get Resource</Link>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
              ))}
              {posts && posts.map((post, index) => (
                <div className="col-12 col-sm-8 col-md-6 col-lg-3 list-item ph2">
                  <div className="list-content bgw br3 ofh bs1">
                    {post.featuredImage &&
                      <Link href={ `/blog/${post.slug}/` } title={ htmlDecode(post.title) } className="dbha" target="_blank">
                        {post.featuredImage.formats.medium &&
                        <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${post.featuredImage.formats.medium.url.includes(cdnUrl) ? post.featuredImage.formats.medium.url : cdnUrl + post.featuredImage.formats.medium.url })`, opacity: 1}}/>
                        }
                        {!post.featuredImage.formats.medium &&
                        <div className="list-content_image-wrap brdr1--bottom bcg3" style={{backgroundImage: `url(${post.featuredImage.url.includes(cdnUrl) ? post.featuredImage.url : cdnUrl + post.featuredImage.url})`, opacity: 1}} />
                        }
                      </Link>
                    }
                    <div className="teaser-text-wrap">
                      <a href="/blog" className="mt.5 mb2 cat-btn">Blog</a>
                      <Link href={ `/blog/${post.slug}/` } target="_blank">
                        <h3 className="teaser-header mb1.8">{ htmlDecode(post.title) }</h3>
                      </Link>
                      <hr className="small orange mb1.8 ml0" />
                      {post.content &&
                        <p className="copy">{ htmlDecode(post.content).substring(0, 80) }&hellip;</p>
                      }
                      <Link className="button uppercase" href={ `/blog/${post.slug}/` } target="_blank">Read More</Link>
                    </div>
                  </div>
                </div>
              ))}
            </>
          }
        </div>
      </div>
    </div>
  )
}
